import { useCallback } from 'react'
import type { AnswerCheckResult, Coordinate, Problem } from '../types'

interface AnswerCheckParams {
  problem: Problem
  looseUnits: Coordinate[] // on 상태인 낱개 인형 목록
  doneCount: number // done 상태 셀 수 (묶인 인형 수)
  isBankFull: boolean
}

export function useAnswerCheck() {
  const check = useCallback((params: AnswerCheckParams): AnswerCheckResult => {
    const { problem, looseUnits, doneCount, isBankFull } = params
    const expected = problem.left * problem.right
    const ones = looseUnits.length
    const tens = doneCount // done 셀 수 = 십의 자리 합산 (항상 10의 배수)

    // 조건 1: 낱개 인형 < 10개
    if (ones >= 10) {
      return { isCorrect: false, tens, ones, expected, failReason: '낱개 인형이 10개 이상입니다' }
    }

    // 조건 2: 은행 가득 참
    if (!isBankFull) {
      return { isCorrect: false, tens, ones, expected, failReason: '은행이 가득 차 있지 않습니다' }
    }

    // 조건 3: 합산 일치
    if (tens + ones === expected) {
      return { isCorrect: true, tens, ones, expected }
    }

    return {
      isCorrect: false,
      tens,
      ones,
      expected,
      failReason: `${tens + ones}은(는) ${expected}과(와) 같지 않습니다`,
    }
  }, [])

  return { check }
}
